import { render } from "./ca-footer.vue?vue&type=template&id=1684e6ac&scoped=true"
import script from "./ca-footer.vue?vue&type=script&lang=js"
export * from "./ca-footer.vue?vue&type=script&lang=js"

import "./ca-footer.vue?vue&type=style&index=0&id=1684e6ac&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1684e6ac"]])

export default __exports__